import { AuthService, type SearchUsersData } from '@/shared/api';
import { useFetchComposable } from '@/shared/lib';

const useUsersSearch = () => {
  const { isLoading, send: usersSearch } = useFetchComposable(
    (searchQuery: NonNullable<SearchUsersData['query']>['q']) =>
      AuthService.searchUsers({ query: { q: searchQuery } }),
  );

  return { isLoading, usersSearch };
};

export { useUsersSearch };
